
// Slick animated classic landing page with premium design

function AnniversaryDinner() {
  const tileStyle = {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    justifyContent: 'center',
    padding: '60px 56px',
    borderRadius: 20,
    background: 'linear-gradient(135deg, #ffffff 0%, #f9fafb 100%)',
    color: '#1f2937',
    textDecoration: 'none',
    fontWeight: 700 as const,
    fontSize: '1.35rem',
    boxShadow: '0 14px 48px rgba(99, 102, 241, 0.2), 0 6px 16px rgba(99, 102, 241, 0.12)',
    border: '2px solid rgba(99, 102, 241, 0.12)',
    transition: 'all 400ms cubic-bezier(0.34, 1.56, 0.64, 1)',
    minHeight: 300,
    position: 'relative' as const,
    overflow: 'hidden' as const,
    letterSpacing: '0.3px'
  };

  const rmsTileStyle = {
    ...tileStyle
  };

  const tilesWrapStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
    gap: 36,
    marginTop: 20,
    maxWidth: 1100,
    width: '100%',
    order: -1
  };

  const tilesWrapBeforeStyle = {
    content: '""',
    position: 'absolute' as const,
    top: 0,
    left: 0,
    right: 0,
    height: '4px',
    background: 'linear-gradient(90deg, #6366f1 0%, #ec4899 50%, #f59e0b 100%)',
    borderRadius: '16px 16px 0 0'
  };

  const navbarStyle = {
    background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 50%, #f97316 100%)',
    padding: '20px 60px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 8px 32px rgba(245, 158, 11, 0.3), 0 4px 12px rgba(245, 158, 11, 0.2)',
    position: 'relative' as const,
    borderBottom: '3px solid rgba(255, 255, 255, 0.2)',
    width: '100%'
  };

  const navbarBeforeStyle = {
    content: '""',
    position: 'absolute' as const,
    top: 0,
    left: 0,
    right: 0,
    height: '2px',
    background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent)'
  };

  const navLogoStyle = {
    height: 60,
    filter: 'drop-shadow(0 4px 12px rgba(0, 0, 0, 0.3))',
    transition: 'all 300ms ease',
    animation: 'logoFloat 3s ease-in-out infinite'
  };

  const navTitleStyle = {
    fontSize: '2.2rem',
    fontWeight: 900 as const,
    color: '#ffffff',
    letterSpacing: '-0.03em',
    textAlign: 'center' as const,
    flex: 1,
    marginRight: 0,
    textShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
    marginLeft: 20
  };

  const containerStyle = {
    maxWidth: 1100,
    margin: '0 auto',
    textAlign: 'center' as const,
    padding: '40px 24px',
    background: 'linear-gradient(135deg, #ffffff 0%, #f0f4ff 50%, #ffffff 100%)',
    minHeight: 'calc(100vh - 82px)',
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    justifyContent: 'flex-start'
  };

  const logoStyle = {
    height: 110,
    filter: 'drop-shadow(0 6px 16px rgba(99, 102, 241, 0.2))',
    transition: 'all 400ms cubic-bezier(0.34, 1.56, 0.64, 1)',
    animation: 'logoFloat 3s ease-in-out infinite',
    display: 'none'
  };

  const titleStyle = {
    marginTop: 28,
    fontSize: '2.4rem',
    fontWeight: 900 as const,
    background: 'linear-gradient(135deg, #6366f1 0%, #ec4899 50%, #f59e0b 100%)',
    WebkitBackgroundClip: 'text' as const,
    WebkitTextFillColor: 'transparent' as const,
    backgroundClip: 'text' as const,
    letterSpacing: '-0.03em',
    animation: 'titleSlideIn 0.8s ease-out',
    whiteSpace: 'nowrap' as const,
    display: 'inline-block'
  };

  const addressStyle = {
    marginTop: 28,
    fontSize: '1.1rem',
    color: '#1f2937',
    fontWeight: 600 as const,
    letterSpacing: '0.5px',
    animation: 'fadeIn 1s ease-out 0.2s both',
    padding: '14px 24px',
    background: 'linear-gradient(135deg, rgba(99, 102, 241, 0.08) 0%, rgba(99, 102, 241, 0.04) 100%)',
    borderRadius: 12,
    border: '1px solid rgba(99, 102, 241, 0.15)',
    display: 'inline-block',
    boxShadow: '0 4px 12px rgba(99, 102, 241, 0.1)'
  };

  const cardImageStyle = {
    height: 70,
    marginBottom: 16,
    filter: 'drop-shadow(0 4px 12px rgba(99, 102, 241, 0.2))',
    transition: 'all 400ms cubic-bezier(0.34, 1.56, 0.64, 1)',
    objectFit: 'contain' as const,
    animation: 'imageFloat 2s ease-in-out infinite'
  };

  const rmsImageStyle = {
    height: 55,
    marginBottom: 14,
    filter: 'drop-shadow(0 3px 10px rgba(99, 102, 241, 0.15))',
    transition: 'all 400ms cubic-bezier(0.34, 1.56, 0.64, 1)',
    objectFit: 'contain' as const,
    animation: 'imageFloat 2.5s ease-in-out infinite'
  };

  const cardTextStyle = {
    fontSize: '1.15rem',
    fontWeight: 700 as const,
    letterSpacing: '0.3px'
  };

  const rmsTextStyle = {
    fontSize: '1.15rem',
    fontWeight: 700 as const,
    letterSpacing: '0.3px'
  };

  return (
    <div>
      <div style={navbarStyle}>
        <img
          src="https://stssevastorage.blob.core.windows.net/ykwebsite/logo.png"
          alt="Yugal Kunj Logo"
          style={navLogoStyle}
        />
        <h1 style={navTitleStyle}>Yugalkunj Donation</h1>
      </div>
      <div style={containerStyle}>
        <div style={tilesWrapStyle}>
        <a
          href="/rms"
          style={rmsTileStyle}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-8px) scale(1.02)';
            e.currentTarget.style.boxShadow = '0 16px 48px rgba(99, 102, 241, 0.2)';
            e.currentTarget.style.background = 'linear-gradient(135deg, rgba(99, 102, 241, 0.15) 0%, rgba(99, 102, 241, 0.08) 100%)';
            e.currentTarget.style.borderColor = 'rgba(99, 102, 241, 0.3)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0) scale(1)';
            e.currentTarget.style.boxShadow = '0 8px 24px rgba(99, 102, 241, 0.12)';
            e.currentTarget.style.background = 'linear-gradient(135deg, rgba(99, 102, 241, 0.1) 0%, rgba(99, 102, 241, 0.05) 100%)';
            e.currentTarget.style.borderColor = 'rgba(99, 102, 241, 0.15)';
          }}
        >
          <img
            src="https://www.radhamadhavsociety.org/assets/images/about/i-logo-2.png"
            alt="Radha Madhav Society"
            style={rmsImageStyle}
          />
          <div style={rmsTextStyle}>Radha Madhav Society</div>
        </a>
        <a
          href="/hyc"
          style={tileStyle}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-8px) scale(1.02)';
            e.currentTarget.style.boxShadow = '0 16px 48px rgba(99, 102, 241, 0.2)';
            e.currentTarget.style.background = 'linear-gradient(135deg, rgba(99, 102, 241, 0.15) 0%, rgba(99, 102, 241, 0.08) 100%)';
            e.currentTarget.style.borderColor = 'rgba(99, 102, 241, 0.3)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0) scale(1)';
            e.currentTarget.style.boxShadow = '0 8px 24px rgba(99, 102, 241, 0.12)';
            e.currentTarget.style.background = 'linear-gradient(135deg, rgba(99, 102, 241, 0.1) 0%, rgba(99, 102, 241, 0.05) 100%)';
            e.currentTarget.style.borderColor = 'rgba(99, 102, 241, 0.15)';
          }}
        >
          <img
            src="https://harmonyyouthcenter.org/Content/images/footer.png"
            alt="Harmony Youth Center"
            style={cardImageStyle}
          />
          <div style={cardTextStyle}>Harmony Youth Center</div>
        </a>
        <a
          href="/donate-grocery"
          style={tileStyle}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-8px) scale(1.02)';
            e.currentTarget.style.boxShadow = '0 16px 48px rgba(245, 158, 11, 0.3)';
            e.currentTarget.style.background = 'linear-gradient(135deg, rgba(245, 158, 11, 0.15) 0%, rgba(245, 158, 11, 0.08) 100%)';
            e.currentTarget.style.borderColor = 'rgba(245, 158, 11, 0.3)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0) scale(1)';
            e.currentTarget.style.boxShadow = '0 8px 24px rgba(245, 158, 11, 0.12)';
            e.currentTarget.style.background = 'linear-gradient(135deg, rgba(245, 158, 11, 0.1) 0%, rgba(245, 158, 11, 0.05) 100%)';
            e.currentTarget.style.borderColor = 'rgba(245, 158, 11, 0.15)';
          }}
        >
          <div style={{ fontSize: '2.5rem', marginBottom: 12 }}>🛒</div>
          <div style={cardTextStyle}>Donate Groceries</div>
        </a>
        <a
          href="/manage-grocery"
          style={tileStyle}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-8px) scale(1.02)';
            e.currentTarget.style.boxShadow = '0 16px 48px rgba(139, 92, 246, 0.3)';
            e.currentTarget.style.background = 'linear-gradient(135deg, rgba(139, 92, 246, 0.15) 0%, rgba(139, 92, 246, 0.08) 100%)';
            e.currentTarget.style.borderColor = 'rgba(139, 92, 246, 0.3)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0) scale(1)';
            e.currentTarget.style.boxShadow = '0 8px 24px rgba(139, 92, 246, 0.12)';
            e.currentTarget.style.background = 'linear-gradient(135deg, rgba(139, 92, 246, 0.1) 0%, rgba(139, 92, 246, 0.05) 100%)';
            e.currentTarget.style.borderColor = 'rgba(139, 92, 246, 0.15)';
          }}
        >
          <div style={{ fontSize: '2.5rem', marginBottom: 12 }}>⚙️</div>
          <div style={cardTextStyle}>Manage Grocery</div>
        </a>
        </div>
      </div>
      <style>{`
        @keyframes logoFloat {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-15px);
          }
        }
        
        @keyframes titleSlideIn {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        
        @keyframes imageFloat {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-8px);
          }
        }
      `}</style>
    </div>
  );
}

export default AnniversaryDinner;
